/**
 * The owner's agent configuration as the editor holds it. Rithmo's API stores & < > " as entities (its input sanitizer),
 * so the stored text is decoded once on load; otherwise every save would send the entities back and encode them again
 * (`"` → `&quot;` → `&amp;quot;`).
 */
import { shownText } from './cb/lib/agentSetupWords'

type Declared = { key: string; note?: string | null; intended_action?: string | null }
export type StoredConfig = {
  instructions?: string | null
  purpose?: string | null
  memberDeclarations?: { tools?: Declared[]; actions?: Declared[] } | null
}

export function configForEditor(c: StoredConfig): { instructions: string; purpose: string; declTools: string; declActions: string } {
  const md = c.memberDeclarations
  return {
    instructions: shownText(c.instructions || ''),
    purpose: shownText(c.purpose || ''),
    declTools: (md?.tools || []).map((t) => (t.note ? `${t.key}: ${shownText(t.note)}` : t.key)).join('\n'),
    declActions: (md?.actions || []).map((a) => (a.intended_action ? `${a.key}: ${shownText(a.intended_action)}` : a.key)).join('\n'),
  }
}
